import { render, staticRenderFns } from "./SystemHome.vue?vue&type=template&id=56c97a9d&scoped=true"
import script from "./SystemHome.vue?vue&type=script&lang=js"
export * from "./SystemHome.vue?vue&type=script&lang=js"
import style0 from "./SystemHome.vue?vue&type=style&index=0&id=56c97a9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c97a9d",
  null
  
)

export default component.exports